<template>
    <div class="material-master-table--container">
        <div class="copy-dtx-table material-master-table--table">
            <table>
                <thead>
                    <tr>
                        <th v-overflow-tooltip>Code</th>
                        <th v-overflow-tooltip>ERP ID</th>
                        <th v-overflow-tooltip>Name</th>
                        <th v-overflow-tooltip>Type</th>
                        <th v-overflow-tooltip>Category</th>
                        <th v-overflow-tooltip>UOM</th>
                        <th v-if="!isExternalCollaborator" v-overflow-tooltip>Process Plan/Lead Time</th>
                        <th v-overflow-tooltip>Committed Inventory</th>
                        <th v-overflow-tooltip>Total Inventory</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!materialMasterList || materialMasterList.length === 0">
                        <td colspan="9" class="no-data-cell">
                            <div style="text-align: center; padding: 1rem;">
                                No Data Found
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(mm, index) in materialMasterList" :key="`material-${mm.id}`" class="pointer"
                        :class="{ 'obsolete-row': mm.status === 2 }" @click="openDetailModal($event, index)">
                        <td class="relative pointer" v-overflow-tooltip>
                            <div class="v-center">
                                <div class="chip-popover v-center h-center" v-if="mm.thumbnailUrl">
                                    <img :src="mm.thumbnailUrl" alt="Material Thumbnail">
                                </div>

                                <div class="elipsis-text" v-overflow-tooltip>
                                    {{ mm.custom_material_id || '--' }}
                                </div>
                            </div>

                            <div v-if="mm?.material_product_code?.product_code" class="pt-3 elipsis-text vendorName"
                                v-overflow-tooltip>
                                Prod: {{ mm?.material_product_code?.product_code }}
                            </div>
                        </td>
                        <td class="elipsis-text" v-overflow-tooltip>{{ mm.erp_material_id || '--' }}</td>
                        <td>
                            <div class="elipsis-text" v-overflow-tooltip>{{ mm.material_name || '--' }}</div>
                            <div class="pt-3 elipsis-text vendorName" v-overflow-tooltip>{{ mm?.material_description }}
                            </div>
                        </td>
                        <td class="elipsis-text" v-overflow-tooltip>
                            <span :class="getTypeClass(mm?.material_type_value?.name)">{{ mm?.material_type_value?.name
                                }}</span>
                        </td>
                        <td class="elipsis-text" v-overflow-tooltip>{{ mm?.material_group_details?.name || '--' }}</td>
                        <td :class="{ redColor: !list_of_unit_of_material[mm.unit_of_material] }" v-overflow-tooltip>
                            {{ mm.material_unit_details.name || '--' }}
                        </td>
                        <td v-if="!isExternalCollaborator" v-overflow-tooltip>
                            <div class="elipsis-text" :style="{ color: '#0606f6' }" v-overflow-tooltip>
                                {{ materialMasterList[index]?.workflow_template?.name }}
                            </div>
                            <div class="pt-3" :style="{ color: '#686464' }">
                                {{ mm.lead_time || '--' }} {{ mm.lead_time ? 'day' : '' }}
                            </div>
                            <div class="vendor-container">
                                <label class="vendorName elipsis-text" v-overflow-tooltip>
                                    {{ mm?.material_default_vendor?.company_name }}
                                </label>
                                <img v-if="!isExternalCollaborator && Array.isArray(mm.vendor_materials) && mm.vendor_materials.length && showEditButton"
                                    class="editVendor" v-tooltip="'Edit'" src="~@/assets/images/pencil.svg" alt=""
                                    @click.stop="openVendorModal(mm)" />
                            </div>
                        </td>
                        <td class="inventory-cell" v-overflow-tooltip @click.stop="openInventoryModal(mm)">
                            <span v-if="mm?.inventory !== null && mm?.inventory !== undefined" class="inventory-link">
                                {{ mm.inventory }}
                            </span>
                            <span v-else>--</span>
                        </td>
                        <td class="elipsis-text" v-overflow-tooltip>
                            <span v-if="mm?.inventory !== null && mm?.inventory !== undefined">{{ mm.inventory }}</span>
                            <span v-else>--</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex space-between">
            <pagination-2 class="mt-4" :length="totalCount" :pageNumber="pageNumber" :perPage="perPage"
                @selectPage="$emit('selectPage', $event)" />
            <div class="total-count mt-4">
                <span>Total Materials: &nbsp; <b>{{ totalCount }}</b></span>
            </div>
        </div>
        <modal @close="closeDetailModal" :open="detailModalObject?.isOpen" title="Material Master Detail View"
            :closeOnOutsideClick="true">
            <detail-material-master v-if="detailModalObject.selectedIndex !== -1"
                :materialMaster="materialMasterList[detailModalObject.selectedIndex]" />
            <detail-material-master v-else-if="detailModalObject.selectedMaterialObj"
                :materialMaster="detailModalObject.selectedMaterialObj" />
        </modal>
        <!-- <modal @close="closeEditModal" :open="editModalObject?.isOpen" title="Update Material Master">
            <edit-mateterial-master @close="closeEditModal" @updateAndClose="updateAndClose"
                v-if="editModalObject.selectedIndex !== -1"
                :materialMaster="materialMasterList[editModalObject.selectedIndex]" />
        </modal> -->
        <alternateMaterialModal v-if="showAlternateModal" :item="selectedMaterial" :all-items="allMaterials"
            :approval-plan="workflowSteps" size="lg" @close="closeAlternateModal" @add-alternate="handleAddAlternate"
            @view-alternate="handleViewAlternate" @validation-error="handleValidationError" />
        <modal @close="closeMaterialObsoleteModal" :open="materialObsoleteObject?.isOpen"
            title="Are you sure you want to make the material obsolete">
            <div v-if="materialObsoleteObject.selectedIndex !== -1">
                <span>Making the material <span
                        class="weight-600">{{ materialMasterList[materialObsoleteObject.selectedIndex].material_name }}</span>
                    as obsolete will impact the boms associated with this material</span>
                <span class="productbom-title block mt-4">Products and BOMS where this material is used:</span>
                <associated-bom-table :loading="false" :productsAndBoms="materialObsoleteObject.productsAndBoms" />
                <div class="flex flex-end py-3 m">
                    <button class="btn btn-black mr-3" @click="closeMaterialObsoleteModal">CANCEL</button>
                    <button class="btn" @click="confirmMaterialObsolete">CONFIRM</button>
                </div>
            </div>
        </modal>
        <modal @close="vendorObject.isOpen = false" :open="vendorObject.isOpen">
            <h2 class="modal-title">Select Default Vendor</h2>
            <p class="modal-subtitle">
                <span :style="{ color: '#c9a26c' }">Choose default vendor for</span> <strong>Pressure Relief
                    Valve</strong>
            </p>
            <div v-if="!isExternalCollaborator" class="vendor-card-container">
                <div class="vendor-card default-vendor" v-for="(vendor, key) in vendorObject.vendorList" :key="key"
                    @click="selectVendor(vendor.tenant_company_association.target_tenant.id)">
                    <div class="card-icon-check">
                        <span class="radio"
                            :class="{ checked: selectedVendor === vendor.tenant_company_association.target_tenant.id }"></span>
                    </div>

                    <div class="card-details">
                        <div class="card-header">
                            <span class="vendor-name">{{ vendor.tenant_company_association.target_tenant.company_name
                                }}</span>
                        </div>
                        <div class="logistics-info">
                            <div class="logistics-item">
                                <span class="label">Lead Time</span>
                                <span class="value">{{ vendor.lead_time }}</span>
                            </div>
                            <div class="logistics-item">
                                <span class="label">MOQ</span>
                                <span class="value">{{ vendor.moq }} units</span>
                            </div>
                        </div>
                        <div class="pricing-tiers">
                            <span class="label">Pricing Tiers</span>
                            <div class="tiers-list" v-for="(item, key) in vendor.vendor_materials_pricing_tiers"
                                :key="key">
                                <p>
                                    ₹{{ item.unit_price }}/ unit {{ item.min_quantity }} - {{ item.max_quantity }},
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedVendor === vendor.tenant_company_association.target_tenant.id">
                        <span class="current-default">● Current Default</span>
                    </div>
                </div>
            </div>
            <div class="flex flex-end pt-10 m">
                <button class="btn btn-white mr-3 pointer" @click="vendorObject.isOpen = false">Cancel</button>
                <button class="btn pointer" @click="updateDefaultVendor">
                    Set as default
                </button>
            </div>
        </modal>
        <attached-doc-view v-if="detailObject.open" :linkedDocs="detailObject.linkedDocs" @close="closeDetail" />
        <material-inventory-modal :open="showInventoryModal" :materialId="selectedInventoryMaterial?.id"
            :materialName="selectedInventoryMaterial?.name" :totalQuantity="selectedInventoryMaterial?.inventory"
            @close="closeInventoryModal" />
    </div>
</template>

<script>
import {
  UpdateMaterialStatus,
  GetProductsUsingMaterialQuery,
  UnitOfMaterial,
  GetMaterialMasterData,
  updatedefaultVenodor
} from '@/api'
import Modal from '@/components/common/modal.vue'
import alternateMaterialModal from '@/components/materialMaster/alternateMaterialModal.vue'
import pagination2 from '@/components/common/pagination2.vue'
import AssociatedBomTable from '@/components/materialMaster/associatedBomTable.vue'
import DetailMaterialMaster from '@/components/materialMaster/detailMaterialMaster.vue'
// import EditMateterialMaster from '@/components/materialMaster/editMateterialMaster.vue'
import MaterialInventoryModal from '@/components/materialMaster/materialInventoryModal.vue'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import { success, alert } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import AttachedDocView from '@/components/document/attachedDocView.vue'
import { mapGetters } from 'vuex'
// import CustomDropdown from '@/components/common/customDropdown.vue'
// import loadingCircle from '@/components/common/loadingCircle.vue'
import Config from '@/config'
export default {
  components: { pagination2, Modal, DetailMaterialMaster, AssociatedBomTable, AttachedDocView, MaterialInventoryModal, alternateMaterialModal },
  name: 'materialMasterTable',
  props: {
    materialMasterList: {
      type: Array,
      default: () => ([])
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    selectedWorkFlow: null,
    showAlternateModal: false,
    selectedMaterial: null,
    allMaterials: [],
    workflowSteps: [],
    WFTLoading: false,
    workflows: [],
    workflowSearchKeyword: '',
    workFlowDropdownObject: {
      index: -1,
      open: false
    },
    detailModalObject: {
      isOpen: false,
      selectedIndex: -1,
      selectedMaterialObj: null
    },
    editModalObject: {
      isOpen: false,
      selectedIndex: -1
    },
    materialObsoleteObject: {
      isOpen: false,
      selectedIndex: -1,
      productsAndBoms: null
    },
    showInventoryModal: false,
    selectedInventoryMaterial: null,
    detailObject: {
      open: false,
      linkedDocs: []
    },
    popoverIndex: null,
    list_of_unit_of_material: {},
    Config: Config,
    vendorObject: {
      isOpen: false,
      vendorList: null,
      materialId: null
    },
    selectedVendor: null
  }),
  computed: {
    ...mapGetters(['user', 'getUserById']),
    ...mapGetters(['isTenantAdmin', 'isProjectAdmin', 'isTenantViewer', 'isProjectViewer', 'isOnProjectLevel', 'collaborator', 'isExternalCollaborator']),
    availableMaterials () {
      if (!this.selectedMaterial || !this.materialMasterList) {
        return this.materialMasterList || []
      }
      return this.materialMasterList.filter(m => m.id !== this.selectedMaterial.id)
    }
  },
  methods: {
    selectVendor (id) {
      this.selectedVendor = id
    },
    handleWorkFlowSelection (workflow) {
      this.selectedWorkFlow = workflow
    },
    getStatusClass (status) {
      switch (status) {
      case 1:
        return 'status-active'
      case 2:
        return 'status-obselete'
      case 3:
        return 'status-hold'
      case 4:
        return 'status-locked'
      default:
        return ''
      }
    },
    getTypeClass (status) {
      switch (status) {
      case 'Make':
        return 'type-make'
      case 'Buy':
        return 'type-buy'
      }
    },
    openDetailModal (event, index) {
      if (
                event?.target?.tagName?.toLowerCase() === 'select' ||
                event?.target?.closest('select')
      ) {
        return
      }
      this.detailModalObject.isOpen = true
      this.detailModalObject.selectedIndex = index
      this.$router.replace({ query: { selectedMaterialId: this.materialMasterList[index].id } })
    },
    closeDetailModal () {
      this.detailModalObject.isOpen = false
      this.detailModalObject.selectedIndex = -1
      this.detailModalObject.selectedMaterialObj = null
      this.$router.replace({ query: {} })
    },
    openInventoryModal (material) {
      if (material?.inventory === null || material?.inventory === undefined) {
        return
      }
      this.selectedInventoryMaterial = {
        id: material.id,
        name: material.material_name,
        inventory: material.inventory
      }
      this.showInventoryModal = true
    },
    closeInventoryModal () {
      this.showInventoryModal = false
      this.selectedInventoryMaterial = null
    },
    openMaterialObsoleteModal (index) {
      const loader = new Loader()
      loader.show()
      const productsAndBoms = {}
      GetProductsUsingMaterialQuery(this.materialMasterList[index].id).then((res) => {
        res.core_material_master[0].bom_material_items.forEach(item => {
          const productCode = item.core_bom.product_bom ? item.core_bom.product_bom.product_code : ''
          if (productCode) {
            if (productsAndBoms[productCode]) {
              productsAndBoms[productCode].push(item.core_bom.name)
            } else {
              productsAndBoms[productCode] = [item.core_bom.name]
            }
          }
        })
        if (Object.keys(productsAndBoms).length) {
          this.materialObsoleteObject.isOpen = true
          this.materialObsoleteObject.selectedIndex = index
          this.materialObsoleteObject.productsAndBoms = productsAndBoms
        } else {
          ConfirmationDialog(`Are you sure you want to make the material <b> ${this.materialMasterList[index].material_name} </b> obselete`, (res) => {
            if (res) {
              this.materialObsoleteObject.selectedIndex = index
              this.confirmMaterialObsolete()
            }
          })
        }
      }).catch(() => {
        alert('Failed to fetch data')
      })
        .finally(() => {
          loader.hide()
        })
    },
    closeMaterialObsoleteModal () {
      this.materialObsoleteObject.isOpen = false
      this.materialObsoleteObject.productsAndBoms = null
      this.materialObsoleteObject.selectedIndex = -1
    },
    UpdateMaterialStatus (index, status) {
      const loader = new Loader()
      loader.show()
      const materialMasterTemp = JSON.parse(JSON.stringify(this.materialMasterList[index]))
      return new Promise((resolve, reject) => {
        UpdateMaterialStatus(materialMasterTemp.id, status).then(() => {
          loader.hide()
          materialMasterTemp.status = status
          success('Updated material Status')
          materialMasterTemp.status = status
          this.$emit('updateList', {
            data: materialMasterTemp,
            index
          })
          resolve()
        }).catch((err) => {
          loader.hide()
          alert('Something went wrong')
          reject(err)
        })
      })
    },
    confirmMaterialObsolete () {
      this.UpdateMaterialStatus(this.materialObsoleteObject.selectedIndex, 2).then(() => {
        this.closeMaterialObsoleteModal()
      }).catch(() => {
        alert('Unable to make material obsolete')
      })
    },
    openChangeStatusModal (index, status) {
      const { material_name: materialName } = this.materialMasterList[index]
      ConfirmationDialog(`Are you sure you want to ${status} the material ${materialName}`, (res) => {
        if (res) {
          if (status === 'lock') {
            this.UpdateMaterialStatus(index, 4)
          } else if (status === 'unlock' || status === 'activate') {
            this.UpdateMaterialStatus(index, 1)
          }
        }
      })
    },
    updateAndClose (newData) {
      this.$emit('updateList', {
        data: newData,
        index: this.editModalObject.selectedIndex
      })
      this.editModalObject.isOpen = false
      this.editModalObject.selectedIndex = -1
    },
    openDetail (docs) {
      const newDocArray = docs.map((doc) => {
        if (doc.core_document?.associated_versions?.length <= 0) {
          return doc
        } else {
          const latestDoc = doc.core_document?.associated_versions.at(-1)
          if (latestDoc.state === Config.DOC_STATE_MAP.CHECKIN) {
            return latestDoc
          } else if (doc.core_document?.associated_versions.length > 1) {
            return doc.core_document?.associated_versions.at(-2)
          } else {
            return doc
          }
        }
      })

      if (docs.length > 0) {
        this.detailObject = {
          open: true,
          linkedDocs: newDocArray
        }
      } else {
        alert('No documents avaiable')
      }
    },
    closeDetail () {
      this.detailObject = {
        open: false,
        fileId: ''
      }
    },
    listOfUnitOfMaterial () {
      UnitOfMaterial().then((res) => {
        this.list_of_unit_of_material = {}
        res.custom_list_values.forEach((item) => {
          this.list_of_unit_of_material[item.id] = {}
          this.list_of_unit_of_material[item.id].name = item.name
          this.list_of_unit_of_material[item.id].id = item.id
        })
      })
    },
    async MaterialList (list) {
      const materialId = this.$route.query.selectedMaterialId ?? this.$route.query.selectedmaterialid
      if (materialId) {
        let materialDetails = list.find(material => material.id === materialId)
        if (!materialDetails) {
          const filter = {
            jump: 0,
            perPage: 1000,
            id: materialId
          }
          const res = await GetMaterialMasterData(filter, true)
          materialDetails = res.core_material_master[0]
        }
        this.detailModalObject.isOpen = true
        this.detailModalObject.selectedMaterialObj = materialDetails
      }
    },
    openAlternateModal (material, index) {
      this.selectedMaterial = {
        id: material.id,
        materialId: material.custom_material_id,
        name: material.material_name,
        product_code: material.material_product_code ? material.material_product_code?.product_code : '--',
        alternates: material.alternates || []
      }
      this.allMaterials = this.materialMasterList.filter(m => m.id !== material.id)
      this.workflowSteps = this.getWorkflowSteps(material)
      this.showAlternateModal = true
    },
    closeAlternateModal () {
      this.showAlternateModal = false
      this.selectedMaterial = null
    },
    handleAddAlternate (materialId, payload) {
      console.log('Adding alternate:', materialId, payload)
      this.closeAlternateModal()
    },
    handleViewAlternate (alternate) {
      console.log('Viewing alternate:', alternate)
    },
    handleValidationError (error) {
      this.$toast.error(error.message)
    },
    openVendorModal (data) {
      this.vendorObject.isOpen = true
      this.selectedVendor = data.material_default_vendor?.id
      if (!this.isExternalCollaborator) this.vendorObject.vendorList = data.vendor_materials
      this.vendorObject.materialId = data.id
    },
    updateDefaultVendor () {
      const materialId = this.vendorObject.materialId
      updatedefaultVenodor(materialId, this.selectedVendor).then((res) => {
        if (res.update_core_material_master) {
          this.vendorObject.isOpen = false
          success('Default vendor updated.')
        } else {
          alert('something went wrong')
        }
      })
    },
    getWorkflowSteps (material) {
      return [
        { id: 1, name: 'Engineering Review', stage: 'Technical', duration: '2-3 days' },
        { id: 2, name: 'Quality Assessment', stage: 'QA', duration: '3-5 days' },
        { id: 3, name: 'Supply Chain Approval', stage: 'Procurement', duration: '1-2 days' }
      ]
    }
  },
  async mounted () {
    this.listOfUnitOfMaterial()
  },
  watch: {
    '$route.query.selectedMaterialId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.MaterialList(this.materialMasterList)
      }
    },
    materialMasterList: {
      immediate: true,
      handler (newList) {
        if (newList.length) {
          this.MaterialList(newList)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data-cell {
    text-align: center !important;
    font-size: var(--text-base);
    color: #6c757d;
}

.overflow-visible {
    min-width: 150px !important;
    max-width: 150px !important;
    overflow: visible !important;
}

.wft {
    width: 80%;

    &-search {
        padding: 5px 10px;
        background: white;
        position: sticky;
        top: 0;
        z-index: 10;
    }

    &-input {
        width: 100%;
        padding: 5px 10px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        background-color: transparent;
    }
}

.workflow-modal {
    min-width: 400px;
    max-width: 500px;
}

.icon-img {
    width: 12px;
    height: 12px;
    margin-top: 1px;
}

.modal-title {
    font-size: 1.2em;
    font-weight: 500;
    color: #333;
    margin: 0;
}

.modal-subtitle {
    padding: 10px 0px 15px;
}

.vendor-card-container {
    max-height: 73vh;
    overflow: auto;
    padding-right: 11px;
}

.vendor-container {
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
}

.vendor-card {
    display: flex;
    background-color: #f6eee4;
    border: 2.2px solid #c9a26c;
    border-radius: 8px;
    margin-top: 12px;
    padding: 15px 15px 15px 0;
}

.card-icon-check {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px 24px;
}

.card-details {
    flex-grow: 1;
    padding: 0px 16px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.current-default {
    background-color: #e0f7e9;
    color: #2e7d32;
    font-size: 0.8em;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
}

.logistics-info {
    display: flex;
    gap: 30px;
    margin-bottom: 15px;
}

.logistics-item .label {
    display: block;
    font-size: 0.85em;
    color: #777;
    margin-bottom: 2px;
}

.logistics-item .value {
    display: block;
    font-size: 1.2em;
    font-weight: 700;
    color: #333;
}

.pricing-tiers .label {
    display: block;
    font-size: 0.85em;
    color: #777;
    margin-bottom: 4px;
}

.pricing-tiers .tiers-list {
    font-size: 1em;
    color: #333;
    margin: 0;
}

.type-make {
    display: inline-block;
    padding: 3px 6px;
    border-radius: 7px;
    font-weight: 500;
    text-align: center;
    background-color: #efcaef;
    color: purple;
}

.type-buy {
    display: inline-block;
    padding: 3px 6px;
    border-radius: 7px;
    font-weight: 500;
    text-align: center;
    background-color: #d6f6d6;
    color: #047d04;
}

.vendorName {
    align-items: center;
    font-size: var(--text-s);
    color: #8c8989;
}

.editVendor {
    width: 20px;
    height: 18px;
    margin: 0px 3px;
}

.vendor-radio {
    display: flex;
    align-items: flex-start;
}

.radio {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #c4c4c4;
    position: relative;
}

.radio.checked {
    border-color: #c99551;
    background-color: #c99551;
}

.radio.checked::after {
    content: "✔";
    font-size: var(--text-s);
    color: #ffffff;
    font-weight: bold;
    padding: 0px 3px 0px 3px;
    position: absolute;
}

.status {
    font-size: var(--text-m);
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    padding: 3px 4px;
    border-radius: 3px;
    background-color: orange;

    &-locked {
        background-color: #fff3cd;
        color: #856404;
    }

    &-hold {
        background-color: #cce5ff;
        color: #004085;
    }

    &-active {
        background-color: #d4edda;
        color: #155724;
    }

    &-obselete {
        background-color: #ffcccc;
        color: #d60000;
    }
}

.total-count {
    background-color: var(--gray-bgcolor);
    padding: 0.5rem 0.5rem 0.5rem;
    border: 1px solid var(--gray-bgcolor);
    border-radius: 0.2em;
    width: fit-content;
    padding-inline: 10px;
    margin-left: auto;
}

.mm-table {
    th {
        z-index: 4;
    }

    .chip {
        img {
            width: 10px;
            height: 100%;
            z-index: 5;
        }

        padding: 2px 8px;
        font-size: var(--text-xs1);
        background-color: rgba(var(--brand-rgb), 0.5);
        z-index: 0;
        border-radius: 2px;
        position: relative;

        &-popover {
            position: absolute;
            width: 145px;
            height: 81px;
            background: transparent;
            top: -30px;
            z-index: 4;
            display: flex;
            justify-content: start;
            transform: translateX(30%);

            & img {
                width: auto;
                height: 100%;
                object-fit: fill;
                border: 1px solid rgb(51, 40, 40, 0.5);
                border-radius: 4px;
                -webkit-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
                -moz-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
                box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
            }
        }
    }

    .thumbnail {
        width: 60px;
        height: 60px;
    }
}

.custom-list-select {
    max-width: 100%;
    min-width: 20%;
    margin-right: auto;
    font-size: var(--text-s);
    background-color: var(--brand-light-color);
    line-height: 1;
    border: 1px solid var(--brand-color);
    border-radius: 4px;
    padding: 2px 1px;
}

.obsolete-row {
    background-color: var(--gray);
}

.material-master-table {
    height: calc(100% - 60px);
    margin-top: 10px;

    &--table {
        max-height: calc(100vh - 250px);
    }

    &--container {
        max-height: calc(100% - 60px);
        overflow: auto;

        table {

            th,
            td {
                max-width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                border-bottom: 1px solid #e5e7eb;

                &.inventory-cell {
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        text-decoration: underline;
                    }

                    .inventory-link {
                        cursor: pointer;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .column {
                padding: 10px 8px;
            }

            .edit-1 {
                margin: 0 2px;
            }
        }
    }

    .pagination-footer {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        &-total {
            margin-top: 16px;
            display: flex;
            background: var(--gray-bgcolor);
            padding: 0.5rem 0.5rem 0.5rem;
            border: 1px solid var(--gray-bgcolor);
            border-radius: 0.2em;
            width: fit-content;
            padding-inline: 10px;
            margin-left: auto;
        }
    }

    .productbom-title {
        color: var(--text-color-1);
        font-weight: 500;
        font-size: 0.9em;
    }

    .btn {
        color: var(--white)
    }

    .redColor {
        color: red
    }

    .attachments {
        z-index: 1;
    }
}

.chip-popover {
    position: relative;
    width: 32px;
    height: 32px;
    margin-right: 8px;
    flex-shrink: 0;
    display: flex;
    top: 0;
    transform: none;

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }
}
</style>
